import { createSelector } from 'reselect'
import { questInDraftAfterPublished } from '../utils/review'

const _currentReviewsFilteredForQuestState = state => {
  if (questInDraftAfterPublished(state.quest.item)) {
    return []
  } else {
    return state.quest.currentReviews
  }
}

export const currentReviewsFilteredForQuestState = createSelector(
  [_currentReviewsFilteredForQuestState],
  reviews => {
    return reviews
  }
)



// WEBPACK FOOTER //
// ./src/selectors/review.js